const SESSION_EXPIRE_CODE: string = "E004"

export {SESSION_EXPIRE_CODE}